import React, { useState } from "react";
import { TextField, Button, Grid, Box, Typography } from "@mui/material";
import mailerService from "@/services/mailer.service";
import { MailDto } from "@/data/dtos/mail.dto";
import { setError, setMessage } from "@/actions/message";
import { useDispatch } from "react-redux";

export default function FictionalApplyForm() {
  const dispatch = useDispatch();
  const [applicationFormData, setApplicationFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    date: "",
  });

  const handleApplicationFormChanged = (event: any) => {
    const { name, value } = event.target;
    setApplicationFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fieldTranslations: Record<string, string> = {
    name: "Ad",
    surname: "Soyad",
    email: "E-Posta",
    phone: "Telefon",
    suggestedTeacherName: "Önerilen Öğretmen Adı",
    suggestedTeacherLink: "Önerilen Öğretmen Linki",
    suggestedCourseName: "Önerilen Kurs Adı",
    suggestedCourseDescription: "Önerilen Kurs Açıklaması",
  };

  const formatMailHTML = (data: Record<string, any>, title: string): string => {
    const rows = Object.entries(data)
      .map(
        ([key, value]) => `
          <tr>
            <td style="padding: 8px; border-bottom: 1px solid #ddd;">
              <strong>${fieldTranslations[key] || key}</strong>
            </td>
            <td style="padding: 8px; border-bottom: 1px solid #ddd;">
              ${value}
            </td>
          </tr>
        `
      )
      .join(""); // Tüm satırları birleştir

    return `
      <div style="font-family: Arial, sans-serif; line-height: 1.5; color: #333;">
        <h2 style="color: #d32f2f;">📌${title}</h2>
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <th style="text-align: left; padding: 8px; background: #f4f4f4;">Alan</th>
            <th style="text-align: left; padding: 8px; background: #f4f4f4;">Değer</th>
          </tr>
          ${rows}
        </table>
        <p style="margin-top: 20px; color: #555;">Bu form kullanıcının girdiği bilgilerle oluşturulmuştur.</p>
      </div>
    `;
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      const mailDto: MailDto = {
        subject: "Kurgusal Etkinlik Başvurusu",
        html: formatMailHTML(
          applicationFormData,
          "Kurgusal Etkinlik Başvurusu"
        ),
        from: {
          name: applicationFormData.name,
          address: applicationFormData.email,
        },
      };
      const response = await mailerService.sendMail(mailDto);

      if (response?.status === 201) {
        dispatch(setMessage("Mail başarıyla gönderildi!", 5000) as any);
        setApplicationFormData({
          name: "",
          surname: "",
          email: "",
          phone: "",
          company: "",
          message: "",
          date: "",
        });
      } else {
        dispatch(setError("Mail gönderilirken bir hata oluştu."));
      }
    } catch (error: any) {
      alert("Bağlantı hatası: " + error?.message);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 600,
        mx: "auto",
        mt: 0,
        p: 3,
        boxShadow: 3,
      }}
      className="bg-[#FADA7A]"
    >
      <Typography variant="h5" mb={2} textAlign="center">
        Kurgusal Etkinlik Başvurusu
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Ad"
              name="name"
              value={applicationFormData.name}
              onChange={handleApplicationFormChanged}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Soyad"
              name="surname"
              value={applicationFormData.surname}
              onChange={handleApplicationFormChanged}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Şirket"
              name="company"
              value={applicationFormData.company}
              onChange={handleApplicationFormChanged}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="E-Posta"
              name="email"
              type="email"
              value={applicationFormData.email}
              onChange={handleApplicationFormChanged}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Telefon"
              name="phone"
              value={applicationFormData.phone}
              onChange={handleApplicationFormChanged}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Talep Edilen Etkinlik İçeriği"
              name="message"
              value={applicationFormData.message}
              onChange={handleApplicationFormChanged}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Talep Tarihi"
              name="date"
              type="date"
              value={applicationFormData.date}
              onChange={handleApplicationFormChanged}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Gönder
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
